import React from 'react';
import { Button } from './ui/button';
import { Star } from 'lucide-react';
import { restaurantInfo } from '../mock';

const Hero = ({ onReservationClick, onOrderClick, onFullMenuClick }) => {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_2e08abfd-9d61-4b02-9272-bb8dc030b0a2/artifacts/z1z9uc4f_IMG_5449.jpeg)',
          filter: 'brightness(0.4) contrast(0.9)'
        }}
      />
      <div className="absolute inset-0 bg-black/20" /> {/* Extra subtle overlay */}
      
      <div className="relative z-10 text-center text-white px-6 max-w-5xl animate-fade-in-up flex flex-col items-center">
        <span className="text-xs uppercase tracking-[0.3em] text-white/80 mb-6 border-b border-white/30 pb-2">
          Miskolc · Hungary
        </span>
        <h2 className="text-6xl md:text-8xl font-serif font-normal text-white leading-none tracking-tight mb-2">
          aKonyhád!
        </h2>
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-white/80 mb-12 font-sans font-medium">
          bisztró · menü · tőlünk · neked
        </p>
        <p className="text-lg md:text-xl mb-12 font-light text-white/90 tracking-wide max-w-2xl font-sans">
          {restaurantInfo.description}
        </p>
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col sm:flex-row gap-8 justify-center">
            <Button 
              size="lg" 
              className="bg-white text-black hover:bg-white/90 border-transparent text-xs tracking-widest px-12"
              onClick={onReservationClick}
            >
              Asztalfoglalás
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              className="bg-transparent border-white text-white hover:bg-white hover:text-black text-xs tracking-widest px-12"
              onClick={onOrderClick}
            >
              Rendelés most
            </Button>
          </div>
          <Button 
            size="lg" 
            variant="outline"
            className="bg-transparent border-white text-white hover:bg-white hover:text-black text-xs tracking-widest px-12"
            onClick={onFullMenuClick}
          >
            Teljes étlap
          </Button>
        </div>
        <div className="mt-16 flex items-center justify-center gap-4 border-t border-white/20 pt-8 w-full max-w-md">
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star key={star} className="w-4 h-4 fill-white text-white" />
            ))}
          </div>
          <span className="text-xs uppercase tracking-wider text-white/80">
            {restaurantInfo.rating} / 5 ({restaurantInfo.reviewCount} vélemény)
          </span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
